import { useEffect, useState } from "react";
import TablePagination from "../../../components/TablePagination";
import api from "../../../services/api";

import "react-toastify/dist/ReactToastify.css";

import { displayDateTime } from "../../../utils/masks";
import IHistDTO from "../../../models/IHistDTO";
import { StatusType } from "../../../models/enums/StatusType";
import { TypeHistory } from "../../../models/enums/TypeHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import MemberHistoricDetail from "../member-historic-detail/MemberHistoricDetail";
import Member from "../../../models/Member";
import moment from "../../../utils/momentConfig";
import ILetterDetailDTO from "../../../models/ILetterDetailDTO";

interface Params {
  memberId: number;
  refresh: boolean;
  memberCurrent?: Member;
}

export default function MemberHistoricList(props: Params) {
  const { memberId, refresh, memberCurrent } = props;

  const [openDetail, setOpenDetail] = useState<boolean>(false);
  const [member, setMember] = useState();
  
  const columns = [
    {
      name: "Histórico",
      grow: 2,
      cell: (row: IHistDTO) => <label className={row.status == StatusType.INACTIVE ? 'uk-text-danger' : ''}>{row.reason}</label>
    },
    {
      name: "Obs.",
      cell: (row: IHistDTO) => (
        [TypeHistory.CHANGE_RECORDS].indexOf(row.reason) < 0 ? (
          <label
            className={row.status == StatusType.INACTIVE ? 'uk-text-danger' : ''}
          >
            {handleShowNote(row)}
          </label>
        ) : (
          <a href="#" onClick={(ev)=> { ev.preventDefault(); handleDetail(row); }}
            uk-tooltip="title: Ver Diferenças"
          >
            <FontAwesomeIcon icon={faEye} />
          </a>
        )
      )
    },
    {
      name: "Realizado",
      grow: 2,
      cell: (row: IHistDTO) => (
        <div className="uk-flex uk-flex-column uk-text-xsmall uk-text-light">
          <label className={row.status == StatusType.INACTIVE ? 'uk-text-danger' : ''}>
            Por: {row.createdBy}<br/>
            Em: {displayDateTime(row.createdDate)}
          </label>
          {
            row.status == StatusType.INACTIVE && (
              <label className="uk-text-danger">
                <strong>Cancelado em: {displayDateTime(row.modifiedDate)}</strong>
                <br/>
                Por: {row.modifiedBy}
              </label>
            )
          }
          {
            (row.status == StatusType.ACTIVE && row.historyClosedOn) && (
              <label className="uk-text-success">
                <strong>Finalizado em: {displayDateTime(row.modifiedDate)}</strong>
                <br/>
                Por: {row.modifiedBy}
              </label>
            )
          }
        </div>
      )
    }
  ];

  useEffect(() => {
  }, []);

  const fetchHist = async (page: number, limit: number) => {
    try {
      const response = await api.get(`members/${memberId}/historic`, {
        params: {
          page: page,
          limit: limit
        },
      });

      return response;
    } catch {
      return { data: [], total: 0 };
    }
  };

  const afterCloseModal = () => {
    setOpenDetail(false);
    setMember(undefined);
  }

  const handleDetail = (row: any) => {
    setMember(row.note);
    setOpenDetail(true);
  }

  const handleShowNote = (row: IHistDTO) => {
    if (![TypeHistory.CHANGE_LETTER, TypeHistory.RECOMMENDATION_LETTER].includes(row.reason)) {
      return row.note;
    }

    if (row.historyClosedOn?.id) {
      return <div className="uk-text-italic">Carta de Mudança assinada em {moment(row.modifiedDate).format('DD/MM/yyyy HH:mm:ss')}</div>
    }

    if (row.status === StatusType.INACTIVE) {
      return <div className="uk-text-danger">Carta Cancelada</div>
    }

    let note = row.note;

    if (!note) return;
  
    if (note.startsWith('{') && note.endsWith('}')) {
      const noteObj = JSON.parse(note) as ILetterDetailDTO;
      note = noteObj.formatedNote ?? '';
    }

    if (note?.includes('-')) {
      const lines = note.split('-');
      return <div className="uk-margin-small-top">{lines.map(l => <><span>{l}</span><br/><br/></>)}</div>
    }

    return note;
  }

  return (
    <div id="page-member-historic">   
      <TablePagination
        columns={columns}
        fetchData={fetchHist}
        refresh={refresh}
      />
      <MemberHistoricDetail 
        open={openDetail} 
        memberChanged={member}
        memberCurrent={memberCurrent}
        afterCloseModal={afterCloseModal}
      />
    </div>
  );
}
